import React from "react";

/**
 * The heart mark on the closing panel. Path and viewBox taken from the
 * reference; fills from currentColor so the parent sets the tint.
 */
const Heart = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M32 54s-18-10-18-24a10 10 0 0 1 18-6 10 10 0 0 1 18 6c0 14-18 24-18 24Z"
      fill="currentColor"
    />
  </svg>
);

export default Heart;
